.pagehead {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.title {
  margin: 0 0 4px;
  font-size: var(--co-size-callout);
  font-weight: 800;
  line-height: var(--co-leading-moderate);
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.sub {
  color: var(--co-text-additional);
  font-size: var(--co-size-small);
}

.actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

@media (max-width: 760px) {
  .actions {
    margin-left: 0;
    width: 100%;
  }
}
